import {icon} from '#core/utils/style-utils.js';

import {generatePrimaryButton} from '#core/application/modules/tiles/button/index.js';

export function fallbackCardsFactory(PALETTE) {
    return {
        FallbackEventCard: {
            showBackgroundSportImage: !PALETTE.PARENT.CARD_WATERMARK_ICON_HIDDEN,
            eventCardBase: {
                title: {
                    style: {
                        ...PALETTE.CARD_FALLBACK_TITLE_TEXT,
                    },
                },
            },
            contentText: {
                style: {
                    whiteSpace: 'normal',
                    ...PALETTE.CARD_FALLBACK_MESSAGE_TEXT,
                },
            },
            sportIcon: {
                icon: icon(PALETTE.CARD_FALLBACK_SPORT_ICON_COLOR),
            },
            betNowContainer: {
                style: {
                    flexGrow: 0,
                    flexShrink: 0,
                    flexBasis: 'auto',
                },
            },
            betNowButton: generatePrimaryButton(PALETTE.CARD_FALLBACK_BET_NOW_BUTTON),
        },
        SportFallbackEventCard: {
            view: {
                backgroundImageContainer: {
                    style: {
                        overflow: 'hidden',
                    },
                },
            },
        },
    };
}
